import { useCallback, useEffect, useState } from 'react';

import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

export interface ImpersonationState {
  active: boolean;
  email?: string;
  startedAt?: string;
  endedAt?: string;
}

export interface UseImpersonationStateResult {
  state: ImpersonationState;
  refresh: () => void;
}

const DEFAULT_STATE: ImpersonationState = { active: false };

/** Reads the current impersonation banner state (who's being impersonated, active flag). */
export function useImpersonationState(): UseImpersonationStateResult {
  const [state, setState] = useState<ImpersonationState>(DEFAULT_STATE);

  const refresh = useCallback(() => {
    void (async () => {
      const stored = (await StorageHandler.load(storageKeys.impersonationState)) as ImpersonationState | false;
      setState(stored || DEFAULT_STATE);
    })();
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { state, refresh };
}
